import { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { ProtectedRoute, LoginCallback } from '@certara/common-react-components';
import { MainLayout } from './components/Layout/MainLayout';
import { SnackbarProvider } from './components/Shared/SnackbarProvider';
import { ContextMenuProvider } from './components/ContextMenu';
import { LoginPage } from './pages/LoginPage';
import { DebugAuth } from './pages/DebugAuth';
import MainPage from './pages/MainPage';

function App() {
  return (
    <>
      <SnackbarProvider />
      <ContextMenuProvider>
        <Suspense
          fallback={
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              minHeight="100vh"
            >
              <CircularProgress />
            </Box>
          }
        >
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            {/* In production (base: '/Load/'), the router sees '/login/callback'.
                In dev (base: '/'), it sees the full '/Load/login/callback'. Both
                routes are registered so the shared CAD callback works in either mode. */}
            <Route path="/login/callback" element={<LoginCallback />} />
            <Route path="/Load/login/callback" element={<LoginCallback />} />

            <Route path="/debug-auth" element={<DebugAuth />} />

            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <MainLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<MainPage />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </ContextMenuProvider>
    </>
  );
}

export default App;
